import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Layout = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled(Typography.Title)`
  margin: 32px 0 24px;
  font-size: 16px;
`;

export const BodyText = styled(Typography.BodyText)`
  margin-left: 12px;
`;
